import { collection, getDocs, orderBy, query, where } from 'firebase/firestore';
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { app, db } from '../Admin/Config/Config';
import { useUser } from '../Auth/UsersContext';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { usePaymentSuccess } from '../Payment/PaymentStatusContext';

export default function BookList() {
  const [allDocs, setAllDocs] = useState([]);
  const navigate = useNavigate();
  const { user } = useUser();
    const { openPaymentSuccess } = usePaymentSuccess();
  


// ========================= FETCHING EBOOKS ========================= //
  const fetchDocs = async (q,value) => {
    const data = [];
    const docs = await getDocs(q);
    docs.forEach((doc) => {
        if(value === "purchased") {
            if(user?.je_courses?.includes(doc.id)){
                data.push({ id: doc.id, ...doc.data() , isPurchased: true});
            }
        } else {
            data.push({ id: doc.id, ...doc.data(), isPurchased: false});
        }
    });
    setAllDocs(data);
  }
  useState(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const cat = urlParams.get("cat");
    const type = urlParams.get("type");
    if (cat && type) {
        if (type === "paperback" && cat !== "purchased") {
          const q = query(
            collection(db, "jaffers_english_books"),
            where("type", "==", type),
            where(cat, "==", true),orderBy("order", "asc")
          );
          fetchDocs(q,cat);
        }
        if(type === "online" && cat !== "purchased") {
          const q = query(
            collection(db, "jaffers_english_books"),
            where("type", "==", type),
            where(cat, "==", true),orderBy("order", "asc")
          );
          fetchDocs(q,cat);
        }
        if (type === "online" && cat === "purchased") {
          const q = query(
            collection(db, "jaffers_english_books"),
            where("type", "==", type),
            orderBy("order", "asc")
          );
          fetchDocs(q,cat);
        }
    } else {
      window.location.href = "/book";
    }
  }, []);

// ================== HANDLE PURCHASE ================== //
    const hanldePurchase = (course) => {
      const functions = getFunctions(app, "asia-south1");
     const payload = {
       study_stream: "Jaffers English",
       amount: parseFloat(course.offer_price) * 100,
       email: user?.email ?? "",
       name: user?.name ?? "",
       mobile: user?.mobile ?? "",
       uid: user?.uid ?? "",
       book_id: course.id,
       title: course.title,
       district: user?.district ?? "",
       purchase_type: "ebook",
       platform: "web"
     };
     const paymentRequest = httpsCallable(functions, "createOrderId");
      paymentRequest({
        img: course.img_url,
        orderdetails: payload,
        amount: parseFloat(course.offer_price)*100,
      }).then((result) => {
         const order = result.data;
         if (order && order !== 404) {
           const options = {
             key: process.env.REACT_APP_RAZOR_KEY,
             amount: order.amount,
             currency: order.currency,
             name: "Jaffer's English",
             description: "E-Book Purchase",
             image: course.img_url,
             order_id: order.id,
             method: {
               netbanking: true,
               card: true,
               upi: false, // 👈 this disables UPI in the Checkout form
               wallet: true,
             },

             handler: function (response) {
              openPaymentSuccess({
                status: "success",
                orderId: order.id,
                paymentId: response.razorpay_payment_id,
                courseTitle: "E-Book purchace",
                amount: order.amount / 100,
              });  
             },
             prefill: {
               name: order.notes.user_name,
               email: user.email,
               contact: user.mobile,
             },
             notes: {
               address: "Razorpay Corporate Office",
             },
             theme: {
               color: "#3399cc",
             },
             modal: {
               ondismiss: function () {
                 // setloading(false);
               },
             },
           };

          try {
            const rzp1 = new window.Razorpay(options);
            rzp1.open();

            rzp1.on("payment.failed", function (response) {
              openPaymentSuccess({
                status: "failed",
                orderId: order.id||"",
                paymentId: response.razorpay_payment_id||"",
                courseTitle: "E-Book purchace",
                amount: order.amount / 100,
                message: response.error.code,
              });            });
          } catch (error) {
            console.error("Razorpay Error:", error);
            openPaymentSuccess({
              status: "failed",
              orderId: order.id||"",
              courseTitle: "E-Book purchace",
              amount: order.amount / 100,
            });          }
         }
      });
    }


      // ========================= HANDLE NAVIGATION AND READ ========================= //
      const handleNavigation = (id) => {
        navigate(`/book-details?id=${id}`);
      };
    const handleRead = (id) => {
      navigate("/viewbooks",{state:{url:id}});
    }
  return (
    <div className="mx-auto mt-12">
      <div className="mx-auto p-4 max-w-7xl lg:px-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 mt-2">
        {allDocs.map((book) => (
          <div className="bg-black p-4 border border-gray-700 text-left rounded-2xl relative shadow-md flex flex-col">
            <img
              src={book.img_url}
              alt="Book Cover"
              className="w-full h-44 sm:h-48 object-contain rounded p-2"
            />

            <div className="px-1 mt-3">
              <p className="text-white font-semibold text-base sm:text-lg line-clamp-2">{book.title}</p>
            </div>

            <p className="text-gray-500 px-1 text-xs sm:text-sm mt-2 line-clamp-2">
              {book.book_overview}
            </p>
            
            <div className="border-b py-2 border-gray-500 mt-2"></div>
            
            {!book.isPurchased && (
              <div className="px-1 mt-3">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-white text-lg sm:text-xl font-semibold">₹{book.offer_price}</span>
                  <span className="line-through text-red-500 text-xs sm:text-sm">
                    ₹{book.price}
                  </span>
                  {parseFloat(book.price) - parseFloat(book.offer_price) > 0 && (
                    <span className="px-2 py-1 bg-white text-gray-900 border text-xs font-semibold rounded">
                      {
                        ((parseFloat(book.price) - parseFloat(book.offer_price)) /
                          parseFloat(book.price) *
                        100
                      ).toFixed(0)}
                      % OFF
                    </span>
                  )}
                </div>
              </div>
            )}

            <div className="mt-auto pt-4 space-y-3">
              {!book.isPurchased ? (
                <button
                  onClick={() => hanldePurchase(book)}
                  className="w-full text-center bg-emerald-700 hover:bg-emerald-600 text-white text-sm sm:text-base px-4 py-2.5 rounded-2xl transition cursor-pointer"
                >
                  Buy Now
                </button>
              ) : (
                <button
                  onClick={() => handleRead(book.id)}
                  className="w-full text-center bg-emerald-700 hover:bg-emerald-600 text-white text-sm sm:text-base px-4 py-2.5 rounded-2xl transition cursor-pointer"
                >
                  Read Now
                </button>
              )}
              <button
                onClick={() => handleNavigation(book.id)}
                className="w-full text-center border border-gray-400 hover:border-gray-300 text-gray-100 text-sm sm:text-base px-4 py-2.5 rounded-2xl transition cursor-pointer"
              >
                View Details
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
